export const CSSRPromptText = {
  HEADING: 'Consider administering the C-SSRS',
  BODY: 'screened positive for suicidal thinking (question 9 on PHQ9). As clinical best practice, consider further evaluation using the Columbia-Suicide Severity Rating Scale (C-SSRS).',
  CALL_TO_ACTION: 'Administer C-SSRS',
};

export const FORM_LIST_MEASURES_TITLE = 'Measures';

export const FORM_LIST_MEASURES_COMPLETED_PREFIX = 'Completed ';

export const FORM_LIST_CLIENT_MEASURE_INCOMPLETE_ARIA_LABEL = 'Client measure is incomplete';

export const FORM_LIST_INCOMPLETE_TAG = 'INCOMPLETE';

export const FORM_LIST_MEASURES_PARTIALLY_COMPLETED_PREFIX = 'Partially completed ';

export const FORM_LIST_MEASURES_LAST_COMPLETED_PREFIX = 'Last completed ';

export const FORM_LIST_SUBMITTED_PREFIX = 'Submitted ';

export const FORM_LIST_CLIENT_FORM_INCOMPLETE_ARIA_LABEL = 'Client form is incomplete';

export const FORM_LIST_SAFETY_PLAN_FORM_TITLE = 'Safety Plan';

export const FORM_LIST_THERAPY_REASONS_QUESTION_NAME = 'therapy_reasons';

export const FORM_LIST_SEEKING_HELP_FOR_PREFIX = 'Seeking help for: ';

export const FORM_LIST_INTAKE_FORM_TITLE = 'Intake Form';

export const FORM_LIST_CSSRS_FORM_TITLE = 'C-SSRS  - Suicide risk';

export const FORM_LIST_CSSRS_FORM_DESCRIPTION = 'Consider administering the C-SSRS to support suicide risk assessment';

export const FORM_LIST_DATE_OPTION_MONTH = 'short';

export const FORM_LIST_DATE_OPTION_DAY = 'numeric';

export const FORM_LIST_DATE_OPTION_YEAR = 'numeric';

export const FORM_LIST_LOCALE_DATE_OPTIONS = {
  month: FORM_LIST_DATE_OPTION_MONTH,
  day: FORM_LIST_DATE_OPTION_DAY,
  year: FORM_LIST_DATE_OPTION_YEAR,
} as const;
